import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
export var CLOSE_SOURCES = {
  BACKDROP: 1,
  CLOSE_BUTTON: 2,
  ESCAPE: 3,
  ITEM_CLICK: 4
};
export default (function () {
  var decoratorConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(ComponentAsModal, _React$Component);

      function ComponentAsModal() {
        var _this;

        _classCallCheck(this, ComponentAsModal);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(ComponentAsModal).call(this));
        _this.state = {
          belowOverlay: false
        };
        _this.handleToggleHide = _this.handleToggleHide.bind(_assertThisInitialized(_this));
        _this.handleAllClicks = _this.handleAllClicks.bind(_assertThisInitialized(_this));
        _this.handleCloseClick = _this.handleCloseClick.bind(_assertThisInitialized(_this));
        _this.handleBackdropClick = _this.handleBackdropClick.bind(_assertThisInitialized(_this));
        return _this;
      }

      _createClass(ComponentAsModal, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          if (__CLIENT__ || __TEST__) {
            this.escListener = this.handleEscKeypress.bind(this);
            document.addEventListener('keydown', this.escListener);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if ((__CLIENT__ || __TEST__) && this.escListener) {
            document.removeEventListener('keydown', this.escListener);
          }
        }
      }, {
        key: "handleBackdropClick",
        value: function handleBackdropClick() {
          var onModalClose = this.props.onModalClose;

          if (onModalClose) {
            onModalClose(CLOSE_SOURCES.BACKDROP);
          }
        }
      }, {
        key: "handleCloseClick",
        value: function handleCloseClick() {
          var onModalClose = this.props.onModalClose;

          if (onModalClose) {
            onModalClose(CLOSE_SOURCES.CLOSE_BUTTON);
          }
        }
      }, {
        key: "handleEscKeypress",
        value: function handleEscKeypress(event) {
          var onModalClose = this.props.onModalClose;

          if (event.keyCode === 27) {
            if (onModalClose && !decoratorConfig.isPersistent) {
              onModalClose(CLOSE_SOURCES.ESCAPE);
            }
          }
        }
      }, {
        key: "handleAllClicks",
        value: function handleAllClicks(event) {
          var onModalClose = this.props.onModalClose;

          if (event && event.target) {
            var target = event.target;

            while (target) {
              if (target.classList && target.classList.contains('modal__closer')) {
                if (onModalClose) {
                  onModalClose(CLOSE_SOURCES.ITEM_CLICK);
                }

                return;
              }

              target = target.parentNode;
            }
          }
        }
      }, {
        key: "handleToggleHide",
        value: function handleToggleHide() {
          var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
          this.setState({
            belowOverlay: val
          });
        }
      }, {
        key: "render",
        value: function render() {
          var modalConfig = this.props.modalConfig;

          var config = _objectSpread({}, decoratorConfig, modalConfig);

          return React.createElement("div", {
            onClick: !config.isPersistent ? this.handleAllClicks : undefined
          }, React.createElement("div", {
            className: classNames('modal', config.headerClass, {
              'modal--no-scrollbar': config.hideScrollbar,
              'modal--below-overlay': this.state.belowOverlay,
              'modal--center-vertically': config.centerVertically
            })
          }, React.createElement("div", {
            className: classNames('modal__dialog', config.modalDialogClass, {
              'modal__dialog--center-vertically': config.centerVertically
            })
          }, !config.isPersistent && !config.hideClose && React.createElement("a", {
            className: classNames('modal__close m', {
              'modal__close--light': config.lightClose
            }),
            onClick: !config.isPersistent ? this.handleCloseClick : undefined
          }, "Close"), React.createElement("div", {
            className: classNames('modal__border', config.modalBorderClass)
          }, React.createElement("div", {
            className: classNames('modal__content', config.modalContentClass)
          }, React.createElement(Component, _extends({}, this.props, {
            onToggleHide: this.handleToggleHide
          })))))), React.createElement("div", {
            className: classNames('modal__backdrop', config.backdropClass),
            onClick: !config.isPersistent ? this.handleBackdropClick : undefined
          }));
        }
      }]);

      return ComponentAsModal;
    }(React.Component), _defineProperty(_class, "displayName", "Modal(".concat(Component.displayName || Component.name, ")")), _defineProperty(_class, "propTypes", {
      modalConfig: PropTypes.shape({
        backdropClass: PropTypes.string,
        centerVertically: PropTypes.bool,
        headerClass: PropTypes.string,
        hideClose: PropTypes.bool,
        hideScrollbar: PropTypes.bool,
        isPersistent: PropTypes.bool,
        lightClose: PropTypes.bool,
        modalBorderClass: PropTypes.string,
        modalContentClass: PropTypes.string,
        modalDialogClass: PropTypes.string
      }),
      onModalClose: PropTypes.func
    }), _temp;
  };
});